import { render, staticRenderFns } from "./PeopleCard.vue?vue&type=template&id=73b66cb1&scoped=true&"
import script from "./PeopleCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./PeopleCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PeopleCard.vue?vue&type=style&index=0&id=73b66cb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b66cb1",
  null
  
)

export default component.exports